export default __webpack_public_path__ + "static/media/btn_rechercher.91afb87f.svg";